<ul class="nav nav-pills m-b-10">
  @for (section of downloadSections; track section) {
    <li class="nav-item">
      <a class="nav-link" tabindex="0" (keyup.enter)="displayDownloadSection(section)" (click)="displayDownloadSection(section)" [class.active]="section.displayed">
        @if (section.label) {
          {{ section.label }}
        } @else {
          {{ "download." + section.value | translate }}
        }
      </a>
    </li>
  }
</ul>
@if (displayedDownloadSection) {
  @if (showDownloadFilter) {
    <div class="m-b-10">
      <myp-product-filter [showSortType]="true" [showSortDirection]="true" [showListGrid]="false" (filterChanged)="filterDownloads($event)" (sortChanged)="sortDownloads()"></myp-product-filter>
    </div>
  }
  <div class="grid-container pad-10">
    @for (dl of filteredDownloads; track dl) {
      <myp-download-tile [dealer]="dealer" [product]="product" [product_id]="product.id" [download]="dl"></myp-download-tile>
    }
  </div>
}
